module.exports = __webpack_public_path__ + "images/patterns/light/BrickVertical.a39768a78f9eabb62da6.svg";